export default __webpack_public_path__ + "static/media/box-playable-ads.57103b13.jpeg";